<template>
  <router-link-localed :to="localedURL('/weather')" class="cx-link" v-if="weather.temp != '-'" :aria-label="$t('weather.weather')">
    <ul class="cx-list--sm m-submenu-weather">
      <li class="cx-list__item">
        <template v-if="weather.warnings.length > 0">
          <span 
            v-for="warning in weather.warnings"
            :key="warning.type + '_' + warning.inforce"
          >
            <cx-img
              tag="span"
              class="weather-icon--alert" 
              style="margin: 0 0.2em;"
              :imgSrc="weatherImgSrcType(warning)"              
              svg
              ignoreBnw
            ></cx-img>
          </span>
        </template> 
        <span v-if="weather.status">
          <cx-img
            :key="weather.status"
            tag="span"
            class="weather-icon" 
            :imgSrc="weatherImgSrc(weather)"
            svg
          ></cx-img>
        </span> 
      </li>
      <li class="cx-list__item">
        {{$t('weather.temp')}}{{$t('common.colon')}}<span v-if="tempInfo.notice" style="margin-right: 0.5rem"><i :class="tempInfo.icon"></i></span><span>{{weather.temp}}°C</span>
      </li>
      <li class="cx-list__item">
        {{$t('weather.humi')}}{{$t('common.colon')}}<span>{{weather.humi}}%</span>
      </li>
    </ul>
  </router-link-localed>
  <content-placeholders v-else 
    class="cx-list--sm"
    rounded
  >
    <content-placeholders-text 
      :lines="1" 
      :animated="false"
      class="--single-line" 
      style="width: 200px;"/>
  </content-placeholders>
</template>

<script>
import { mapState } from 'vuex';
import {imgSrc, imgSrcType} from '../utils/weather'
import getTempIndexData from '../utils/getTempIndexData';
import getUvIndexData from '../utils/getUVIndexData';

export default {
  name: 'main-header-weather-status',
  uit() {
    return  [
      ['weather', [
        'temp',
        'humi',
        'weather'
      ]],
      ['common', ['colon']]
    ];
  },
  computed: {
    ...mapState({
      weather: state => state.weather.brief
    }),
    tempInfo: function() {
      return getTempIndexData(this.weather.tempIdx)
    },
  },
  methods: {
    weatherImgSrc: imgSrc,
    weatherImgSrcType: imgSrcType
  }
};
</script>

<style lang="scss">
  .m-submenu-weather{
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .weather-icon, %weather-icon{
      display: inline-block;
      width: 22px;
      height: 15px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: auto 100%;
      vertical-align: sub;    
    &--alert{
      @extend %weather-icon;
      width: 22px;
    }
  }
.--single-line{
  .vue-content-placeholders-text__line {
    margin: 0px;
  }
}
</style>
